import React from 'react';
import { Text, View } from 'react-native';

import { font as initialFont } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { scale } from '@components/frame';

const ExtensionLabel = ({ C, CC, alwaysDark, item, font = initialFont, fontType = 'Caption 1' }) => {
  const shouldApplyDarkModeColors = !!(CC && alwaysDark);
  const textColor = shouldApplyDarkModeColors ? CC('Label/Dark/Quaternary') : C('Label/Light/Quaternary');
  const wrapperColor = shouldApplyDarkModeColors ? CC('Label/Dark/Inverted') : C('Label/Light/Inverted');

  return (
    <View style={{ paddingHorizontal: scale(4), borderRadius: scale(20), backgroundColor: wrapperColor }}>
      <Text numberOfLines={1} style={[font[fontType], { color: textColor, textAlign: 'center', textTransform: 'uppercase' }]}>
        {item?.extensionOriginal}
      </Text>
    </View>
  );
};

export default ColorWrapper(ExtensionLabel);
